




















import {Component, Vue} from 'vue-property-decorator';
import FormHeader from '@/app/common/component/FormHeader.vue';
import RegisterForm from '@/app/auth/register/RegisterForm.vue';
import HeaderImg from '@/app/common/component/HeaderImg.vue';
import NotificationService from '@/app/common/service/NotificationService';
import AuthService from '@/app/common/service/AuthService';

@Component({
  name: 'AfterRegisterContainer',
  components: {FormHeader, RegisterForm, HeaderImg},
})
export default class RegisterContainer extends Vue {
  public isSuccess: boolean = false;
  public loading: boolean = true;
  get logoUrl(): string | null {
    return this.$store.getters.logoUrl;
  }

  public created() {
    this.setLoadingState(true);
    this.activateAccount();
  }
  private setLoadingState(state: boolean) {
    this.$store.commit('setLoadingState', state);
  }

  private async activateAccount() {
    this.isSuccess = false;
    this.setLoadingState(true);
    try {
      await AuthService.activateAccount(this.$route.params.token);
      this.isSuccess = true;
    } catch (e) {
      NotificationService.error(e);
    }
    this.setLoadingState(false);
  }
}
